import React, { useEffect, useMemo, useRef, useState } from "react";
import classes from "../assets/styles/EditCardFunctions.module.css";
import FormInput from "../components/Forms/FormInput";
import baseURL from "../utils/constants/baseUrl";
import { FiTrash2 } from "react-icons/fi";
import { BsImageFill } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import ImageUpload from "../components/ImageUpload";
import Joi from "joi";
import {
  CardBackGroundImages,
  Colors,
  AddMoreCustomUrls,
} from "../utils/data/CardFunctionsData";
import PhoneInput from "react-phone-input-2";
import { Button, Form, Modal } from "react-bootstrap";
import "react-phone-input-2/lib/material.css";
import { useDropzone } from "react-dropzone";
import { SketchPicker } from "react-color";
import _ from "lodash";
import Card from "../components/PageComponents/Function/Card";
import { get, put } from "../server";
import { Card_URL } from "../utils/constants/apiUrl";
import {
  accountType,
  loggedInUser,
  teamIDCheck,
  subscribedPackage,
} from "../utils/store";
import { useAtom } from "jotai";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import showToast from "../helpers/showToast";
import AddEditCardSchema from "../utils/SchemasValidation/AddEditCardSchema";
import ValidateSchema from "../helpers/ValidateSchema";
import uploadImage from "../helpers/uploadImage";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import socialMediaLinksSchema from "../utils/SchemasValidation/ModalSocialMediaLinksSchema";
import { ReactComponent as PersonIcon } from "../assets/images/edit_card_contact_icons/person.svg";
import { ReactComponent as LocationIcon } from "../assets/images/edit_card_contact_icons/location.svg";
import { ReactComponent as BioIcon } from "../assets/images/edit_card_contact_icons/bio.svg";
import { ReactComponent as PhoneIcon } from "../assets/images/edit_card_contact_icons/phone.svg";
import { ReactComponent as ShareIcon } from "../assets/images/edit_card_contact_icons/share.svg";
import { ReactComponent as WebsiteURLIcon } from "../assets/images/edit_card_contact_icons/website_url.svg";
import { ReactComponent as CompanyBuildingIcon } from "../assets/images/edit_card_contact_icons/company_building.svg";
import { ReactComponent as EmailIcon } from "../assets/images/edit_card_contact_icons/email.svg";
import { ReactComponent as BackgroundIcon } from "../assets/images/edit_card_contact_icons/background.svg";
import { formatUrl, validatePhoneWithCountryCode } from "../utils/functions";
import pictureicon from "../assets/images/function_page_icons/picIcon.svg";
import companylogo from "../assets/images/function_page_icons/companylogo.svg";
import crossicon from "../assets/images/global_icons/crossicon.svg";
import Select from "../components/Select";
import CropImageModal from "../components/Modals/CropImageModal";
import listViewImage from "../assets/images/function_page_icons/listview.svg";
import gridViewImage from "../assets/images/function_page_icons/gridview.svg";
import treeViewImage from "../assets/images/function_page_icons/treeview.svg";
import iconViewImage from "../assets/images/function_page_icons/iconview.svg";
import { trackEvent } from "../utils/mixpanel";
import {
  getCardBrandingOverride,
  saveCardBrandingOverride,
} from "../utils/cardBrandingOverrides";

const EditCardFunctions = () => {
  const [cardFunction, setCardFunction] = useState({
    card_type: "",
    first_name: "",
    last_name: "",
    email: "",
    company: "",
    company_position: "",
    logo: "",
    background_image: "",
    profile_image: "",
    color: "",
    country_phone: "",
    phone_number: "",
    description: "",
    address: "",
    country: "",
    city: "",
    state: "",
    website_url: "",
    card_social_media: [],
    pronouns: "",
    card_phone: [],
    team_id: null,
    user_id: null,
    content_view_type: "",
  });

  const [value, setValue] = useState();
  const [errors, setErrors] = useState({});
  const [mediaLinkErrors, setMediaLinkErrors] = useState([]);

  const [loading, setLoading] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [uploadImageOpen, setUploadImageOpen] = useState(false);
  const [colorPickerOpen, setColorPickerOpen] = useState(false);
  const [cardViewOpen, setCardViewOpen] = useState(true);
  const [customMediaLinkOpen, setCustomMediaLinkOpen] = useState(false);

  const [modalMediaLinks, setModalMediaLinks] = useState([]);

  const [customColor, setCustomColor] = useState(false);
  const [customBackgroundImage, setCustomBackgroundImage] = useState(false);
  const [pendingTeamBrandingChange, setPendingTeamBrandingChange] =
    useState(null);
  const brandingOverridesRef = useRef({
    background_image: false,
    color: false,
    logo: false,
  });
  const updateTeamBackgroundRef = useRef(false);
  const updateTeamColorRef = useRef(false);
  const updateTeamLogoRef = useRef(false);
  const teamBackgroundUploadConfirmedRef = useRef(false);
  const teamLogoUploadConfirmedRef = useRef(false);

  const [imageUploadKey, setImageUploadKey] = useState("");

  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [fileData, setFileData] = useState("");
  const [crop, setCrop] = useState();
  const [showModal, setShowModal] = useState(false);
  const [cropType, setCropType] = useState("");

  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [loggedUser] = useAtom(loggedInUser);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [personalAccount] = useAtom(accountType);

  const isTeamMember = (loggedUser?.connected_teams?.length ?? 0) > 0;
  const isTeamOwner = loggedUser?.role?.includes("team_owner") || false;
  const teamBranding = loggedUser?.teams || null;

  const [customPronoun, setCustomPronoun] = useState("");

  const [customLabel, setCustomLabel] = useState([
    {
      index_no: "",
      label: "",
    },
  ]);

  const [customMediaLink, setCustomMediaLink] = useState("");
  const [customMediaLinkError, setCustomMediaLinkError] = useState({});
  const [pronounCheckBox, setPronounCheckBox] = useState(false);
  const [notifyChanges, setNotifyChanges] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");

  const profileRef = useRef(null);
  const logoRef = useRef(null);

  const navigate = useNavigate();
  const { teamId, userId, id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");
  const isTeamOwnerEditingTeamCard = !!(
    isTeamOwner &&
    !personalAccount &&
    teamBranding &&
    cardFunction.card_type === "business" &&
    (teamId || team_id || userTeamId || cardFunction.team_id)
  );

  const handleCloseModal = () => {
    setCrop();
    setShowModal(false);
  };

  // Image helper
  const getImageUrl = (path) => {
    if (!path) return "";
    const cleanPath = typeof path === 'string' ? path.trim() : String(path);
    if (cleanPath.toLowerCase().startsWith("http") || cleanPath.startsWith("data:")) return cleanPath;
    return baseURL.PUBLIC_URL + cleanPath;
  };

  useEffect(() => {
    console.log("cardFunction", cardFunction);
  }, [cardFunction]);

  useEffect(() => {
    if (result) {
      if (cropType == "profile") {
        setCardFunction({ ...cardFunction, profile_image: fileData });
      } else {
        setCardFunction({ ...cardFunction, logo: fileData });
      }

      setCropType("");
    }
  }, [result]);

  const handleCustomPronounChange = (e) => {
    setCustomPronoun(e.target.value);
  };

  const pronounsOptions = [
    { value: "she/her", label: "She/Her" },
    { value: "he/him", label: "He/Him" },
    { value: "they/them", label: "They/Them" },
    { value: "custom", label: "Custom" },
  ];
  const cardViewOptions = [
    { value: "list", label: "List View", image: listViewImage },
    { value: "grid", label: "Grid View", image: gridViewImage },
    { value: "tree", label: "Tree View", image: treeViewImage },
    { value: "icon", label: "Icon View", image: iconViewImage },
  ];
  const imgShapeOptions = [
    { value: "circle", label: "Circle", image: listViewImage },
    { value: "square", label: "Square", image: gridViewImage },
    { value: "rectangular", label: "Rectangular", image: treeViewImage },
  ];
  const [selectedCardView, setSelectedCardView] = useState("list");
  const [profileImageShape, setProfileImageShape] = useState("circle");
  const [logoImageShape, setLogoImageShape] = useState("circle");
  const selectedStyleClass =
    selectedCardView === "list"
      ? "listDesign"
      : selectedCardView === "grid"
        ? "gridDesign"
        : selectedCardView === "tree"
          ? "treeDesign"
          : "iconDesign";
  const handleCardViewChange = (view) => {
    setSelectedCardView(view);
    setCardFunction((prevCardFunction) => ({
      ...prevCardFunction,
      content_view_type:
        view === "list"
          ? "listDesign"
          : view === "grid"
            ? "gridDesign"
            : view === "tree"
              ? "treeDesign"
              : "iconDesign",
    }));
  };
  const selectedShapeClass =
    profileImageShape === "circle"
      ? "circle"
      : profileImageShape === "square"
        ? "square"
        : "rectangular";
  const handleProfileShapeChange = (view) => {
    setProfileImageShape(view);
    setCardFunction((prevCardFunction) => ({
      ...prevCardFunction,
      profile_image_shape:
        view === "circle"
          ? "circle"
          : view === "square"
            ? "square"
            : "rectangular",
    }));
  };
  const handleLogoShapeChange = (view) => {
    setLogoImageShape(view);
    setCardFunction((prevCardFunction) => ({
      ...prevCardFunction,
      logo_shape:
        view === "circle"
          ? "circle"
          : view === "square"
            ? "square"
            : "rectangular",
    }));
  };
  const handlePhoneTypeChange = (e, index) => {
    const type = e.target.value;
    if (
      e.target.value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    const newArray = cardFunction.card_phone.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          phone_type: type,
          // keep extension only for work
          phone_extension: type === "work" ? item.phone_extension || "" : "",
        };
      } else {
        return item;
      }
    });
    setCardFunction({
      ...cardFunction,
      card_phone: newArray,
    });
  };

  // handle phone type input change
  const handlePhoneNumberChange = (value, country, index) => {
    const newArray = cardFunction.card_phone.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          phone_number: value,
          country_phone: `${country.dialCode}`,
        };
      } else {
        return item;
      }
    });
    setCardFunction({
      ...cardFunction,
      card_phone: newArray,
    });
  };

  const handlePhoneExtensionChange = (e, index) => {
    const newArray = cardFunction.card_phone.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          phone_extension: e.target.value,
        };
      }
      return item;
    });

    setCardFunction({
      ...cardFunction,
      card_phone: newArray,
    });
  };

  const handleCustomLabel = (e, index) => {
    const newArray = cardFunction.card_phone.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          custom_label: e.target.value,
        };
      } else {
        return item;
      }
    });
    setCardFunction({
      ...cardFunction,
      card_phone: newArray,
    });
  };

  const addPhoneFormField = () => {
    setCardFunction({
      ...cardFunction,
      card_phone: [
        ...cardFunction.card_phone,
        {
          phone_type: "",
          country_phone: "",
          phone_number: "",
          custom_label: "",
          phone_extension: "",
        },
      ],
    });
  };

  const removePhoneFormField = (i) => {
    let removeCardPhone = [...cardFunction.card_phone];
    removeCardPhone.splice(i, 1);
    setCardFunction({ ...cardFunction, card_phone: removeCardPhone });
    setErrors({});
  };

  // const filteredMediaLinks = useMemo(() => {
  //   const filteredLinks = _.cloneDeep(AddMoreCustomUrls);

  //   const newFilteredLinks = [];
  //   filteredLinks.forEach((item) => {
  //     const found = modalMediaLinks.find(
  //       (single) => single.media_type === item.name
  //     );

  //     if (!found || item.name === "custom") {
  //       newFilteredLinks.push(item);
  //     }
  //   });

  //   return newFilteredLinks;
  // }, [modalMediaLinks]);

  const filteredMediaLinks = useMemo(() => {
    const filteredLinks = _.cloneDeep(AddMoreCustomUrls);
    if (purchasedPackage.id === 1) {
      const newFilteredLinks = [];
      filteredLinks.forEach((item) => {
        const found = modalMediaLinks.find(
          (single) => single.media_type === item.name
        );
        if (!found || item.name === "custom") {
          newFilteredLinks.push(item);
        }
      });
      return newFilteredLinks;
    } else {
      return filteredLinks;
    }
  }, [modalMediaLinks]);

  useEffect(() => {
    fetchSingleCard();
  }, []);

  useEffect(() => {
    if (cardFunction.pronouns) {
      setPronounCheckBox(true);
    }
  }, [cardFunction.pronouns]);

  const fetchSingleCard = async () => {
    setLoading(true);
    let queryParams = "";

    if (teamId || team_id || userTeamId) {
      queryParams = `?team_id=${teamId || team_id || userTeamId}`;
    }

    let { status, message, data } = await get(
      `${Card_URL}/${id}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      const savedBrandingOverride = getCardBrandingOverride(data.id, data.uuid);
      brandingOverridesRef.current = {
        background_image: !!data.background_image,
        color: !!data.color,
        logo: !!data.logo,
      };
      const useTeamBrandingFallback = !!(
        data.team_id || teamId || team_id || userTeamId
      );
      const effectiveLogo =
        savedBrandingOverride.logo ||
        data.logo ||
        (useTeamBrandingFallback ? loggedUser?.teams?.logo : "") ||
        "";
      const effectiveBackground =
        savedBrandingOverride.background_image ||
        data.background_image ||
        (useTeamBrandingFallback
          ? loggedUser?.teams?.card_background_image
          : "") ||
        "";
      const effectiveColor =
        savedBrandingOverride.color ||
        data.color ||
        (useTeamBrandingFallback ? loggedUser?.teams?.card_color : "") ||
        "";
      let card_social_media = [];

      data.cardSocialMedia.forEach((item) => {
        let foundIcon = AddMoreCustomUrls.find(
          (single) =>
            single.name === item.media_type ||
            single.oldName === item.media_type
        );

        card_social_media.push({
          media_type: item.media_type,
          url: item.url,
          icon: item.media_type === "custom" ? "custom" : foundIcon?.icon,
          custom_label: item.custom_label,
        });
      });

      const bgFound = CardBackGroundImages.find(
        (item) => effectiveBackground == item.img
      );

      if (!bgFound) {
        setCustomBackgroundImage(true);
      }
      if (
        effectiveColor &&
        !Colors.some(
          ({ bgColor }) => bgColor.toLowerCase() === effectiveColor.toLowerCase()
        )
      ) {
        setCustomColor(true);
      }

      let newCardPhone = [];
      data.cardPhone.forEach((singlePhone, index) => {
        const standardTypes = ["home", "office", "work"]; // 👈 include work

        const isStandardType = standardTypes.includes(singlePhone.phone_type);

        newCardPhone.push({
          country_phone: singlePhone.country_phone,
          phone_number: singlePhone.phone_number
            ? `${singlePhone.country_phone ? singlePhone.country_phone : ""}${singlePhone.phone_number
            }`
            : "",
          phone_type: isStandardType ? singlePhone.phone_type : "custom",
          custom_label: isStandardType ? "" : singlePhone.phone_type,
          phone_extension: singlePhone.phone_extension || "",
        });
      });

      const customPronounsOrNot = [
        null,
        "",
        "she/her",
        "he/him",
        "they/them",
      ].includes(data.pronouns);

      if (!customPronounsOrNot) {
        setCustomPronoun(data.pronouns);
      } else {
        setCustomPronoun("");
      }

      if (data.pronouns) {
        setPronounCheckBox(true);
      }

      setCardFunction({
        card_type: data.card_type,
        first_name: data.first_name ? data.first_name : "",
        last_name: data.last_name ? data.last_name : "",
        email: data.email ? data.email : "",
        company: data.company ? data.company : "",
        company_position: data.company_position ? data.company_position : "",
        logo: effectiveLogo,
        background_image: effectiveBackground,
        profile_image: data.profile_image ? data.profile_image : "",
        color: effectiveColor,
        country_phone: data.country_phone ? `+${data.country_phone}` : "",
        phone_number: data.phone_number
          ? `${data.country_phone ? data.country_phone : ""}${data.phone_number
          }`
          : "",
        description: data.description ? data.description : "",
        address: data.address ? data.address : "",
        country: data.country ? data.country : "",
        city: data.city ? data.city : "",
        state: data.state ? data.state : "",
        website_url: data.website_url ? data.website_url : "",
        card_social_media: card_social_media,
        pronouns: customPronounsOrNot ? data.pronouns : "custom",
        card_phone: newCardPhone,
        team_id: data.team_id ? data.team_id : null,
        user_id: data.user_id ? data.user_id : null,
        content_view_type: data.content_view_type
          ? data.content_view_type
          : null,
        profile_image_shape: data.profile_image_shape
          ? data.profile_image_shape
          : null,
        logo_shape: data.logo_shape ? data.logo_shape : null,
      });
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  const handleImageChange = (files) => {
    const selectedFile = files[0];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB

    if (selectedFile.size > maxSizeInBytes) {
      showToast(
        false,
        "The selected image size exceeds the maximum limit of 10MB."
      );
      return;
    }

    setCardFunction({ ...cardFunction, [imageUploadKey]: selectedFile });

    if (imageUploadKey === "profile_image") {
      setPreview(URL.createObjectURL(selectedFile));
      setShowModal(true);
      setCropType("profile");
    }
    if (imageUploadKey === "logo") {
      brandingOverridesRef.current.logo = true;
      if (teamLogoUploadConfirmedRef.current) {
        updateTeamLogoRef.current = true;
        teamLogoUploadConfirmedRef.current = false;
      }
      setPreview(URL.createObjectURL(selectedFile));
      setShowModal(true);
      setCropType("logo");
    }

    if (imageUploadKey === "background_image") {
      brandingOverridesRef.current.background_image = true;
      if (teamBackgroundUploadConfirmedRef.current) {
        updateTeamBackgroundRef.current = true;
        teamBackgroundUploadConfirmedRef.current = false;
      }
      setCustomBackgroundImage(true);
    }

    handleUploadImageClose();
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: handleImageChange,
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
  });

  const handleMediaOpen = () => {
    setModalMediaLinks(_.cloneDeep(cardFunction.card_social_media));
    setMediaOpen(true);
  };

  const handleMediaClose = () => {
    setModalMediaLinks([]);
    setMediaLinkErrors({});
    setMediaOpen(false);
  };

  const handleColorPickerOpen = () => setColorPickerOpen(true);

  const handleColorPickerClose = () => setColorPickerOpen(false);

  const handleUploadImageOpen = (key) => {
    if (
      key === "background_image" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    setUploadImageOpen(true);
    setImageUploadKey(key);
  };

  const handleUploadImageClose = () => {
    setUploadImageOpen(false);
    setImageUploadKey("");
  };

  const requestTeamBrandingChange = (type, value = null) => {
    if (!isTeamOwnerEditingTeamCard) {
      return false;
    }

    setPendingTeamBrandingChange({ type, value });
    return true;
  };

  const proceedTeamBrandingChange = () => {
    if (!pendingTeamBrandingChange) return;

    const { type, value } = pendingTeamBrandingChange;
    setPendingTeamBrandingChange(null);

    if (type === "color") {
      brandingOverridesRef.current.color = true;
      updateTeamColorRef.current = true;
      setCardFunction((prev) => ({ ...prev, color: value }));
    } else if (type === "background") {
      brandingOverridesRef.current.background_image = true;
      updateTeamBackgroundRef.current = true;
      setCustomBackgroundImage(false);
      setCardFunction((prev) => ({ ...prev, background_image: value }));
    } else if (type === "logo") {
      teamLogoUploadConfirmedRef.current = true;
      handleUploadImageOpen("logo");
    } else if (type === "backgroundUpload") {
      teamBackgroundUploadConfirmedRef.current = true;
      handleUploadImageOpen("background_image");
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (
      name === "pronouns" &&
      value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      setCardFunction({ ...cardFunction, pronouns: "" });
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    setCardFunction({ ...cardFunction, [name]: value });
  };

  const handleMediaChange = (e) => {
    if (
      e.target.value === "custom" &&
      purchasedPackage &&
      purchasedPackage.id == 1
    ) {
      showToast(
        false,
        "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
      );
      return;
    }

    if (e.target.value === "custom") {
      setMediaOpen(false);
      setCustomMediaLinkOpen(true);
    }
    const found = AddMoreCustomUrls.find(
      (item) => item.name === e.target.value
    );

    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks.push({
      media_type: found.name,
      url: "",
      icon: found.name === "custom" ? "custom" : found.icon,
      custom_label: "",
    });

    setModalMediaLinks(newSocialMediaLinks);
  };

  const validateCustomMediaLink = () => {
    let newErrors = ValidateSchema(
      { customMediaLink },
      Joi.object({
        customMediaLink: Joi.string().max(50).required().messages({
          "string.empty": `Please enter Custom Media Name`,
          "string.max": `Custom Media Name must be maximum 50 characters!`,
        }),
      })
    );

    setCustomMediaLinkError(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const handleCustomMediaNameSave = () => {
    if (!validateCustomMediaLink()) return;

    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks[newSocialMediaLinks.length - 1].custom_label =
      customMediaLink;

    setModalMediaLinks(newSocialMediaLinks);

    setCustomMediaLinkOpen(false);
    setCustomMediaLink("");
    setMediaOpen(true);
  };

  const handleCustomMediaModalClose = () => {
    setCustomMediaLinkOpen(false);

    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);
    newSocialMediaLinks.splice(newSocialMediaLinks.length - 1, 1);
    setModalMediaLinks(newSocialMediaLinks);

    setMediaOpen(true);
  };

  const handleModalUrlChange = (e, index) => {
    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);

    newSocialMediaLinks[index].url = formatUrl(e.target.value);

    setModalMediaLinks(newSocialMediaLinks);
  };

  const handleMedialSave = () => {
    if (!validateMediaModalForm()) return;

    setCardFunction({ ...cardFunction, card_social_media: modalMediaLinks });
    handleMediaClose();
  };

  const handleModalMediaDelete = (index) => {
    let newSocialMediaLinks = _.cloneDeep(modalMediaLinks);
    newSocialMediaLinks.splice(index, 1);
    setModalMediaLinks(newSocialMediaLinks);
  };

  const validateForm = () => {
    let newErrors = ValidateSchema(cardFunction, AddEditCardSchema);

    setErrors(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const validateMediaModalForm = () => {
    let newErrors = ValidateSchema(modalMediaLinks, socialMediaLinksSchema);

    setMediaLinkErrors(newErrors);

    if (Object.keys(newErrors).length) return false;

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // Validate phone number
    setErrors({});
    if (cardFunction.pronouns === "custom" && customPronoun.length > 20) {
      setErrors({
        custom_pronouns: "Custom pronouns can be max 20 characters long",
      });
      return;
    }

    for (let index = 0; index < cardFunction.card_phone.length; index++) {
      const data = cardFunction.card_phone[index];
      if (data.phone_type || data.phone_number) {
        if (data.phone_type === "") {
          setErrors({
            [`phone_number${index}`]: "Please select phone type",
          });
          return;
        }

        if (data.phone_number === "") {
          setErrors({
            [`phone_number${index}`]: "Please enter phone number",
          });
          return;
        }

        if (data.phone_number.length > data.country_phone.length) {
          let resultPhone = validatePhoneWithCountryCode(
            data.country_phone,
            data.phone_number
          );
          if (resultPhone) {
            setErrors({
              [`phone_number${index}`]: resultPhone,
            });
            return false;
          }
        }

        if (data.phone_type === "custom" && data.custom_label === "") {
          setErrors({
            [`lable${index}`]: "Please enter custom phone label",
          });
          return;
        }

        if (data.phone_type === "custom" && data.custom_label.length > 20) {
          setErrors({
            [`lable${index}`]: "Custom Label can be max 20 characters long",
          });
          return;
        }
      }
    }

    setLoading(true);

    let payload = _.cloneDeep(cardFunction);

    // Handle website Url
    payload.website_url = formatUrl(payload.website_url);

    if (notifyChanges) {
      payload.is_notify_users = 1;
      payload.notification_message = notificationMessage;
    } else {
      payload.is_notify_users = 0;
      payload.notification_message = "";
    }

    if (typeof payload.background_image == "object") {
      const { status, message, data } = await uploadImage(
        "card_background",
        payload.background_image,
        loggedUser?.token
      );

      if (status) {
        payload.background_image = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    if (typeof payload.profile_image == "object") {
      const { status, message, data } = await uploadImage(
        "card_profile",
        payload.profile_image,
        loggedUser?.token
      );

      if (status) {
        payload.profile_image = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    if (typeof payload.logo == "object" && payload.card_type === "business") {
      const { status, message, data } = await uploadImage(
        "card_logo",
        payload.logo,
        loggedUser?.token
      );

      if (status) {
        payload.logo = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    if (payload.card_type === "personal") {
      payload.logo = "";
    }

    payload.card_social_media.forEach((item) => {
      delete item.icon;
    });

    if (payload.card_phone.length > 0) {
      let cardPhoneArr = payload.card_phone.map((item, index) => {
        if (item.phone_type === "custom") {
          return {
            ...item,
            phone_type: item.custom_label ? item.custom_label : "custom",
            phone_number: item.phone_number.slice(
              item.country_phone.length,
              item.phone_number.length
            ),
          };
        } else {
          return {
            ...item,
            phone_number: item.phone_number.slice(
              item.country_phone.length,
              item.phone_number.length
            ),
          };
        }
      });

      cardPhoneArr.forEach((object) => {
        delete object["custom_label"];
      });

      cardPhoneArr = cardPhoneArr.filter(function (el) {
        return el.phone_number != "";
      });

      payload.card_phone = cardPhoneArr;
    }

    if (payload.pronouns === "custom") {
      payload.pronouns = customPronoun;
    }

    if (payload.pronouns === "custom" && customPronoun === "") {
      payload.pronouns = "";
    }

    let { status, message, data } = await put(
      `${Card_URL}/${id}`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    const searchParams = new URLSearchParams(window.location.search);
    const source = dynamicQRCodeId
      ? "QR Code"
      : searchParams.has("team_id") && searchParams.has("user_id")
        ? "Team Function"
        : "Function Page";
    if (status) {
      if (isTeamOwnerEditingTeamCard) {
        saveCardBrandingOverride(id, data?.uuid || cardFunction.uuid, {
          ...(updateTeamBackgroundRef.current
            ? { background_image: payload.background_image }
            : {}),
          ...(updateTeamColorRef.current ? { color: payload.color } : {}),
          ...(updateTeamLogoRef.current ? { logo: payload.logo } : {}),
        });
      }
      trackEvent(`Card Updated from ${source}`, {
        source: dynamicQRCodeId
          ? "QR Code"
          : team_id && user_id
            ? "Team Function"
            : "Function Page",
        card_id: id,
        team_id: payload.team_id || teamId || userTeamId,
        user_id: payload.user_id || userId,
        dynamic_qr_code_id: dynamicQRCodeId || null,
        card_type: payload.card_type,
        payload: { ...payload },
      });
      if (dynamicQRCodeId) {
        if (teamId && userId) {
          navigate(`/function/cards?dynamic_qr_code=${dynamicQRCodeId}`);
        } else {
          navigate(
            `/function/cards?dynamic_qr_code=${dynamicQRCodeId}${team_id && user_id ? `?team_id=${team_id}&user_id=${user_id}` : ""
            }`
          );
        }
      } else if (teamId && userId) {
        navigate(-1);
      } else {
        navigate(
          `/function/cards${team_id && user_id ? `?team_id=${team_id}&user_id=${user_id}` : ""
          }`
        );
      }
    }

    showToast(status, message);

    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }
  const handleShowSidebar = () => {
    let cardView = document.querySelector(".cardView");
    cardView.classList.add("showCardView");
  };

  const handleHideCardView = () => {
    let cardView = document.querySelector(".cardView");
    cardView.classList.remove("showCardView");
  };

  const handleGoBack = () => {
    navigate(-2);
  };

  return (
    <>
      <div className="outerWrapper1">
        <div className="col-md-8 col-12">
          <div className="row">
            <div className="d-flex align-items-center justify-content-between mainWrapper heading">
              <h1 className="">
                {teamId && userId ? (
                  <Link onClick={handleGoBack}>Functions</Link>
                ) : (
                  <Link to="/" className="function-link">
                    Functions
                  </Link>
                )}

                {" > Cards"}
              </h1>
              {/* <div className="view">
                <button onClick={handleShowSidebar}>View Card</button>
              </div> */}
            </div>
          </div>

          <div className="mainWrapper-card d-block p-4">
            {pendingTeamBrandingChange && (
              <div
                className="alert alert-warning d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4"
                role="alert"
              >
                <div>
                  <strong>
                    Change{" "}
                    {pendingTeamBrandingChange.type.startsWith("background")
                      ? "background"
                      : pendingTeamBrandingChange.type === "color"
                        ? "card color"
                        : "logo"}{" "}
                    for only this card?
                  </strong>
                  <div className="mt-1">
                    This{" "}
                    {pendingTeamBrandingChange.type.startsWith("background")
                      ? "background"
                      : pendingTeamBrandingChange.type === "color"
                        ? "card color"
                        : "logo"}{" "}
                    will apply only to this card. Team Branding and all other
                    team or personal cards will not be changed.
                  </div>
                </div>
                <div className="d-flex gap-2 flex-shrink-0">
                  <Button
                    variant="outline-secondary"
                    type="button"
                    onClick={() => setPendingTeamBrandingChange(null)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="warning"
                    type="button"
                    onClick={proceedTeamBrandingChange}
                  >
                    Proceed
                  </Button>
                </div>
              </div>
            )}
            <div className="row gy-3">
              <div className="col-xl-6 col-12">
                <div className="row mb-2">
                  <span className="imageHeaderLabel">Your Photo</span>
                </div>

                <div className="row align-items-center mobileViewWrapper">
                  <div className="col-4">
                    <ImageUpload
                      imageLink={true}
                      imageUrl={getImageUrl(cardFunction.profile_image)}
                      width="72px"
                      height="72px"
                      enableClick={false}
                      dummyImage={pictureicon}
                    />
                  </div>

                  <div className="col-8">
                    <Button
                      variant="primary"
                      className="uploadBtn w-auto"
                      // onClick={() => profileRef.current.click()}
                      onClick={() => handleUploadImageOpen("profile_image")}
                    >
                      Upload New
                    </Button>
                    <input
                      accept="image/*"
                      type="file"
                      name="profile_image"
                      ref={profileRef}
                      style={{ display: "none" }}
                      onChange={(e) =>
                        setCardFunction({
                          ...cardFunction,
                          profile_image: e.target.files[0],
                        })
                      }
                    />
                    <button
                      className="removeImgBtn"
                      onClick={() =>
                        setCardFunction({ ...cardFunction, profile_image: "" })
                      }
                    >
                      Remove Profile Picture
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-12">
                {cardFunction.card_type === "business" ? (
                  <>
                    <div className="row mb-2">
                      <span className="imageHeaderLabel">Logo</span>
                    </div>

                    <div className="row">
                      <div className="col-4">
                        <ImageUpload
                          imageLink={true}
                          imageUrl={getImageUrl(cardFunction.logo)}
                          width="72px"
                          height="72px"
                          enableClick={false}
                          dummyImage={companylogo}
                        />
                      </div>

                      <div className="col-8 align-items-center">
                        <button
                          className="uploadBtn"
                          onClick={() =>
                            !isTeamMember &&
                            (requestTeamBrandingChange("logo") ||
                              handleUploadImageOpen("logo"))
                          }
                          disabled={isTeamMember}
                          style={isTeamMember ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                        >
                          Upload New
                        </button>
                        <input
                          accept="image/*"
                          type="file"
                          name="logo"
                          ref={logoRef}
                          style={{ display: "none" }}
                          onChange={(e) => {
                            brandingOverridesRef.current.logo = true;
                            setCardFunction({
                              ...cardFunction,
                              logo: e.target.files[0],
                            });
                          }}
                        />
                        <button
                          className="removeImgBtn"
                          onClick={() => {
                            if (!isTeamMember) {
                              brandingOverridesRef.current.logo = false;
                              setCardFunction({
                                ...cardFunction,
                                logo: loggedUser?.teams?.logo || "",
                              });
                            }
                          }}
                          disabled={isTeamMember}
                          style={isTeamMember ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                        >
                          Remove Company Logo
                        </button>
                      </div>
                    </div>
                    {isTeamMember && (
                      <p className="team-restriction-text">
                        Card logo is managed by your team owner and can't be edited here.
                      </p>
                    )}
                  </>
                ) : null}
              </div>
            </div>

            {/* <hr className="divider" /> */}

            <div className="row mt-5">
              <div className="col-12">
                <div
                  className="colorWrapper"
                  style={isTeamMember ? { pointerEvents: "none", opacity: 0.5 } : {}}
                >
                  {Colors.map((color) => {
                    const { id, bgColor } = { ...color };
                    return (
                      <div
                        key={`color${id}`}
                        style={{
                          backgroundColor: bgColor,
                          ...(pendingTeamBrandingChange?.type === "color" &&
                          pendingTeamBrandingChange.value === bgColor
                            ? {
                                outline: "3px solid #ffc107",
                                outlineOffset: "3px",
                              }
                            : {}),
                        }}
                        className={`colorDiv ${cardFunction.color == bgColor
                          ? "selectedColorOption"
                          : null
                          }`}
                        onClick={() => {
                          if (!isTeamMember) {
                            if (
                              !requestTeamBrandingChange("color", bgColor)
                            ) {
                              brandingOverridesRef.current.color = true;
                              setCardFunction({
                                ...cardFunction,
                                color: bgColor,
                              });
                            }
                          }
                        }}
                      />
                    );
                  })}
                </div>
                {isTeamMember && (
                  <p className="team-restriction-text">
                    Card color is managed by your team owner and can't be edited here.
                  </p>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="sectionHeader">
                  <div className="sectionIconHeader">
                    <BackgroundIcon />
                  </div>
                  <span>Background</span>
                </div>
                <div
                  className="backgroundWrapper"
                  style={isTeamMember ? { pointerEvents: "none", opacity: 0.5 } : {}}
                >
                  {CardBackGroundImages.map((image) => {
                    const { id, img } = { ...image };
                    const isSelected = cardFunction.background_image === img;
                    return (
                      <div className="backgroundImageWrapper">
                        <img
                          key={`backgroundImage${id}`}
                          src={getImageUrl(img)}
                          alt=""
                          // className={
                          //   cardFunction.background_image == img
                          //     ? classes.selectedOption
                          //     : null
                          // }
                          className={isSelected ? "selectedOption" : null}
                          style={
                            pendingTeamBrandingChange?.type === "background" &&
                            pendingTeamBrandingChange.value === img
                              ? {
                                  outline: "3px solid #ffc107",
                                  outlineOffset: "3px",
                                }
                              : undefined
                          }
                          // onClick={() => {
                          //   if (!customBackgroundImage) {
                          //     setCardFunction({
                          //       ...cardFunction,
                          //       background_image: img,
                          //     });
                          //   }
                          // }}
                          onClick={() => {
                            if (
                              !isTeamMember &&
                              !requestTeamBrandingChange("background", img)
                            ) {
                              brandingOverridesRef.current.background_image =
                                true;
                              setCardFunction({
                                ...cardFunction,
                                background_image: img,
                              });
                            }
                          }}
                        />
                        {isSelected && (
                          <div
                            className="bgImgRemoveBtnWrapper"
                            onClick={() => {
                              brandingOverridesRef.current.background_image = false;
                              setCardFunction({
                                ...cardFunction,
                                background_image:
                                  loggedUser?.teams?.card_background_image || "",
                              });
                              setCustomBackgroundImage(false);
                            }}
                          >
                            <MdClose />
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {cardFunction.background_image && customBackgroundImage ? (
                    <div className="customBackgroundWrapper">
                      <img
                        src={
                          cardFunction.background_image
                            ? typeof cardFunction.background_image === "object"
                              ? `${URL.createObjectURL(
                                cardFunction.background_image
                              )}`
                              : getImageUrl(cardFunction.background_image)
                            : ""
                        }
                        alt=""
                        className="selectedOption"
                      />
                      <div className="bgImgClearBtnWrapper">
                        <MdClose
                          className="bgImgClearBtn"
                          onClick={() => {
                            brandingOverridesRef.current.background_image = false;
                            setCardFunction({
                              ...cardFunction,
                              background_image:
                                loggedUser?.teams?.card_background_image ||
                                CardBackGroundImages[0].img,
                            });
                            setCustomBackgroundImage(false);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    // <div
                    //   className={classes.emptyBackgroundImage}
                    //   onClick={() => handleUploadImageOpen("background_image")}
                    // >
                    //   <span>+</span>
                    // </div>
                    <div className="emptyBackgroundImageRow">
                      {/* <div
                        className={classes.emptyBackgroundImage}
                        onClick={() => {
                          setCardFunction({
                            ...cardFunction,
                            background_image: "",
                          });
                          setCustomBackgroundImage(false);
                        }}
                      >
                        <span>-</span>
                      </div> */}
                      <div
                        className="emptyBackgroundImage"
                        onClick={() => {
                          if (
                            !isTeamMember &&
                            !requestTeamBrandingChange("backgroundUpload")
                          ) {
                            handleUploadImageOpen("background_image");
                          }
                        }}
                      >
                        <span>+</span>
                      </div>
                    </div>
                  )}
                </div>
                {isTeamMember && (
                  <p className="team-restriction-text">
                    Card background image is managed by your team owner and can't be edited here.
                  </p>
                )}
              </div>
            </div>

            <div className="row mb-4 shape-wrapper">
              <div className="col-12">
                <div className="sectionHeader">
                  <div className="sectionIconHeader">
                    <BackgroundIcon />
                  </div>
                  <span>Select Content View</span>
                </div>
              </div>
              {cardViewOptions.map((option) => (
                <div
                  className="col-lg-3 text-center shape-card"
                  key={option.value}
                >
                  <div
                    className="contentViewBox"
                    onClick={() => handleCardViewChange(option.value)}
                  >
                    <img src={option.image} alt="" className="viewImage" />
                    <p>{option.label}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="row mb-4 shape-wrapper">
              <div className="col-12">
                <div className="sectionHeader">
                  <div className="sectionIconHeader">
                    <BackgroundIcon />
                  </div>
                  <span>Choose Profile Shape</span>
                </div>
              </div>
              {imgShapeOptions.map((option) => (
                <div
                  className="col-lg-4 text-center shape-card"
                  key={option.value}
                >
                  <div
                    className="contentViewBox"
                    onClick={() => handleProfileShapeChange(option.value)}
                  >
                    <img src={option.image} alt="" className="viewImage" />
                    <p>{option.label}</p>
                  </div>
                </div>
              ))}
            </div>

            {cardFunction.card_type === "business" ? (
              <div className="row mb-4 shape-wrapper">
                <div className="col-12">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <BackgroundIcon />
                    </div>
                    <span>Choose Logo Shape</span>
                  </div>
                </div>
                {imgShapeOptions.map((option) => (
                  <div
                    className="col-lg-4 text-center shape-card
"
                    key={option.value}
                  >
                    <div
                      className="contentViewBox"
                      onClick={() => handleLogoShapeChange(option.value)}
                    >
                      <img src={option.image} alt="" className="viewImage" />
                      <p>{option.label}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : null}

            <div className="row">
              <div className="col-md-6 col-12">
                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <PersonIcon />
                    </div>
                    <span>Full Name</span>
                  </div>
                  <FormInput
                    type="text"
                    name="first_name"
                    placeholder="First name"
                    value={cardFunction.first_name}
                    handleChange={handleChange}
                    error={errors.first_name}
                  />
                  <FormInput
                    type="text"
                    name="last_name"
                    placeholder="Last name"
                    value={cardFunction.last_name}
                    handleChange={handleChange}
                    error={errors.last_name}
                  />
                </div>
                <div className="mb-4">
                  <div>
                    <div
                      className="sectionHeader"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div className="sectionIconHeader">
                          <PersonIcon />
                        </div>
                        <span>Pronouns</span>
                      </div>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          name="pronoun_check"
                          checked={pronounCheckBox}
                          onChange={(e) => {
                            setPronounCheckBox(e.target.checked);

                            if (!e.target.checked) {
                              setCardFunction({
                                ...cardFunction,
                                pronouns: "",
                              });
                              setCustomPronoun("");
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <Select
                        placeholder="Choose your pronouns"
                        options={pronounsOptions}
                        value={cardFunction.pronouns}
                        name="pronouns"
                        disabled={!pronounCheckBox}
                        onChange={handleChange}
                      />
                    </div>
                    {cardFunction.pronouns === "custom" && (
                      <>
                        <div
                          className={
                            errors.custom_pronouns
                              ? "input-group globalInputWithIcon errorInput"
                              : "input-group  globalInputWithIcon"
                          }
                          style={{
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <input
                            placeholder="Please Enter Custom Pronoun"
                            className={
                              errors.custom_pronouns
                                ? "form-control inputError"
                                : "form-control"
                            }
                            value={customPronoun}
                            onChange={handleCustomPronounChange}
                          />
                        </div>
                        <p className="errorText">
                          {errors.custom_pronouns || ""}
                        </p>
                      </>
                    )}
                  </div>
                </div>
                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <BioIcon />
                    </div>
                    <span>About me</span>
                  </div>
                  <textarea
                    // className={classes.textareaInput}
                    className={
                      errors.description
                        ? "globalTextArea errorInput form-control"
                        : "globalTextArea form-control"
                    }
                    type="text"
                    placeholder="Description"
                    name="description"
                    value={cardFunction.description}
                    onChange={handleChange}
                    style={{ width: "-webkit-fill-available" }}
                  ></textarea>
                </div>

                {/* <div className="mb-4">
                  <div className={classes.sectionHeader}>
                    <div className={classes.sectionIconHeader}>
                      <LocationIcon />
                    </div>
                    <span>Location</span>
                  </div>
                  <FormInput
                    type="text"
                    name="city"
                    placeholder="City"
                    value={cardFunction.city}
                    handleChange={handleChange}
                    error={errors.city}
                  />
                  <FormInput
                    type="text"
                    name="state"
                    placeholder="State"
                    value={cardFunction.state}
                    handleChange={handleChange}
                    error={errors.state}
                  />
                  <FormInput
                    type="text"
                    name="country"
                    placeholder="Country"
                    value={cardFunction.country}
                    handleChange={handleChange}
                    error={errors.country}
                  />
                </div> */}
              </div>

              <div className="col-md-6 col-12">
                {cardFunction.card_type === "business" ? (
                  <div className="mb-4">
                    <div className="sectionHeader">
                      <div className="sectionIconHeader">
                        <CompanyBuildingIcon />
                      </div>
                      <span>Company & Job Position</span>
                    </div>
                    <FormInput
                      type="text"
                      name="company"
                      placeholder="Company name"
                      value={cardFunction.company}
                      handleChange={handleChange}
                      error={errors.company}
                    />
                    <FormInput
                      type="text"
                      name="company_position"
                      placeholder="Position name"
                      value={cardFunction.company_position}
                      handleChange={handleChange}
                      error={errors.company_position}
                    />
                  </div>
                ) : null}

                {/* <div className="mb-4">
                  <div className={classes.sectionHeader}>
                    <div className={classes.sectionIconHeader}>
                      <PhoneIcon />
                    </div>
                    <span>Contact Number</span>
                  </div>
                  <PhoneInput
                    country={"us"}
                    onlyCountries={["us"]}
                    inputClass={
                      errors.phone_number
                        ? "phoneNumberInput errorInput"
                        : "phoneNumberInput"
                    }
                    value={cardFunction.phone_number}
                    onChange={(value, country, e, formattedValue) => {
                      setCardFunction({
                        ...cardFunction,
                        phone_number: value,
                        country_phone: `+${country.dialCode}`,
                      });
                    }}
                  />
                  <span className="errorText">{errors.phone_number}</span>
                </div> */}

                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <EmailIcon />
                    </div>
                    <span>Email Address</span>
                  </div>
                  <FormInput
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={cardFunction.email}
                    handleChange={handleChange}
                    error={errors.email}
                  />
                </div>

                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <WebsiteURLIcon />
                    </div>
                    <span>Website</span>
                  </div>
                  <FormInput
                    type="text"
                    name="website_url"
                    placeholder="Url"
                    value={cardFunction.website_url}
                    handleChange={handleChange}
                  />
                </div>
                <div className="mb-4">
                  <div className="sectionHeader">
                    <div className="sectionIconHeader">
                      <LocationIcon />
                    </div>
                    <span>Location</span>
                  </div>
                  <FormInput
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={cardFunction.address}
                    handleChange={handleChange}
                    error={errors.address}
                  />
                  <FormInput
                    type="text"
                    name="city"
                    placeholder="City"
                    value={cardFunction.city}
                    handleChange={handleChange}
                    error={errors.city}
                  />
                  <FormInput
                    type="text"
                    name="state"
                    placeholder="State"
                    value={cardFunction.state}
                    handleChange={handleChange}
                    error={errors.state}
                  />
                  <FormInput
                    type="text"
                    name="country"
                    placeholder="Country"
                    value={cardFunction.country}
                    handleChange={handleChange}
                    error={errors.country}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="sectionHeader">
                  <div className="sectionIconHeader">
                    <PhoneIcon />
                  </div>
                  <span>Contact Number </span>
                </div>
                <div style={{ maxWidth: "387px" }}>
                  {cardFunction.card_phone &&
                    cardFunction.card_phone?.map((element, index) => {
                      return (
                        <div key={index} className="phoneInputOuterWrapper">
                          <div
                            className={`d-flex align-items-center gap-1 phoneInputMainWrapper`}
                          >
                            <div className="d-flex flex-column align-items-start">
                              <div
                                className={`d-flex align-items-center ${errors[`phone_number${index}`]
                                  ? "phoneInputWrapper errorInput"
                                  : "phoneInputWrapper "
                                  } phoneInputMainWrapper`}
                              >
                                <div
                                  className="input-group globalInputWithIcon addCardSelect"
                                  style={{ maxWidth: "100px" }}
                                >
                                  <select
                                    className="form-select customSelect"
                                    onChange={(e) =>
                                      handlePhoneTypeChange(e, index)
                                    }
                                    value={element.phone_type}
                                  >
                                    <option value="">Select</option>
                                    <option value="home">Home</option>
                                    <option value="office">Mobile</option>
                                    <option value="work">Work</option>
                                    <option value="custom">Custom</option>
                                  </select>
                                </div>
                                <div className="addPhoneInput">
                                  <PhoneInput
                                    country={"us"}
                                    enableSearch={true}
                                    countryCodeEditable={false}
                                    inputClass={
                                      errors[`phone_number${index}`]
                                        ? "phoneNumberInput errorInput"
                                        : "phoneNumberInput "
                                    }
                                    value={element.phone_number}
                                    onChange={(value, country) =>
                                      handlePhoneNumberChange(
                                        value,
                                        country,
                                        index
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              {element.phone_type === "work" && (
                                <div className="formInputWrapper">
                                  <FormInput
                                    type="text"
                                    name={`phone_extension${index}`}
                                    placeholder="Enter Phone Extension"
                                    value={element.phone_extension || ""}
                                    handleChange={(e) =>
                                      handlePhoneExtensionChange(e, index)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                            <div className="removePhonutBtnWrapper">
                              <button
                                onClick={() => removePhoneFormField(index)}
                              >
                                <FiTrash2 />
                              </button>
                            </div>
                          </div>
                          <p className="errorText">
                            {errors[`phone_number${index}`]}
                          </p>
                          {element.phone_type === "custom" && (
                            <div
                              className="formInputWrapper"
                              style={{ marginTop: "0px" }}
                            >
                              <label
                                className="inputLabel"
                                style={{ fontSize: "14px" }}
                              >
                                Custom Label
                              </label>
                              <FormInput
                                type="text"
                                name={errors[`lable${index}`]}
                                placeholder={`Enter Phone Label`}
                                value={element.custom_label}
                                error={errors[`lable${index}`]}
                                onChange={(e) => handleCustomLabel(e, index)}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}

                  <div>
                    <div className="addPhonutBtnWrapper">
                      <button onClick={() => addPhoneFormField()}>
                        Add Phone
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="sectionHeader">
                  <div className="sectionIconHeader">
                    <ShareIcon />
                  </div>
                  <span>Social Media</span>
                </div>
                <div className="socialMediaWrapper">
                  {cardFunction.card_social_media.map((single, index) => (
                    <div
                      key={`socialMediaLink${index}`}
                      className="addedSocialLinks"
                    >
                      {single.icon === "custom"
                        ? single.custom_label.charAt(0)
                        : single.icon}
                    </div>
                  ))}
                  <div onClick={handleMediaOpen} className="addMoreSocialLinks">
                    +
                  </div>
                </div>
              </div>
            </div>
            {cardFunction.card_type === "business" ? (
              <div className="row">
                <div className="col-12">
                  <div style={{ maxWidth: "387px" }}>
                    <div className="mb-4 ms-1">
                      <Form.Check
                        type="checkbox"
                        label="Notify user for changes"
                        checked={notifyChanges}
                        onChange={(e) => setNotifyChanges(e.target.checked)}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <div className="sectionHeader">
                        <div className="sectionIconHeader">
                          <BioIcon />
                        </div>
                        <span>Notification Message</span>
                      </div>
                      <textarea
                        // className={classes.textareaInput}
                        className={
                          errors.description
                            ? "globalTextArea errorInput form-control"
                            : "globalTextArea form-control"
                        }
                        type="text"
                        placeholder="Message"
                        name="description"
                        // value={cardFunction.description}
                        // onChange={handleChange}
                        value={notificationMessage}
                        onChange={(e) => setNotificationMessage(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="row">
              <div className="col-12">
                <div className="submitBtnWrapper mobileViewWrapper">
                  <Button variant="primary" onClick={handleSubmit}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-12 cardView">
          <div className="card-views heading">
            {/* <h1>Card Views</h1> */}
            <div className="">
              <Card
                data={{
                  ...cardFunction,
                  pronouns:
                    cardFunction.pronouns === "custom"
                      ? customPronoun
                      : cardFunction.pronouns,
                }}
                handleClose={handleHideCardView}
                content_view_type={selectedStyleClass}
                profile_image_shape={selectedShapeClass}
                preferCardBackground={true}
                preferCardColor={true}
                preferCardLogo={true}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={customMediaLinkOpen}
        onHide={handleCustomMediaModalClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader">
          <span>Custom Media Link Name</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleCustomMediaModalClose}
          />
          {/* <GrClose onClick={handleUploadImageClose} /> */}
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <FormInput
            type="text"
            placeholder="Custom Link Name"
            value={customMediaLink}
            handleChange={(e) => setCustomMediaLink(e.target.value)}
            error={customMediaLinkError.customMediaLink}
          />
        </Modal.Body>

        <Modal.Footer className="mediaModalFooter">
          <button onClick={handleCustomMediaNameSave}>Confirm</button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={mediaOpen}
        onHide={handleMediaClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader">
          <span>Social Links</span>
          <img
            src={crossicon}
            alt=""
            style={{ cursor: "pointer" }}
            onClick={handleMediaClose}
          />
          {/* <GrClose onClick={handleMediaClose} /> */}
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <p>
            Add your social links that will be visible on the homepage of your
            blog.
          </p>

          {/* <select
            className={classes.select}
            value=""
            onChange={handleMediaChange}
          >
            <option value="" selected disabled>
              Add Social Link
            </option>
            {filteredMediaLinks.map((single, index) => (
              <option value={single.name} key={`mediaOption${index}`}>
                {single.name}
              </option>
            ))}
          </select> */}
          <div className="mt-4">
            <Select
              placeholder="Add Social Link"
              options={filteredMediaLinks}
              onChange={(e) => {
                handleMediaChange(e);
              }}
              labelKey="name"
              valueKey="name"
            />
          </div>
          {modalMediaLinks.map((single, index) => (
            <>
              <div
                className="socialMediaModalLink d-flex"
                key={`cardModalLink${index}`}
                style={
                  mediaLinkErrors[`${index}.url`]
                    ? { borderColor: "#e35252" }
                    : null
                }
              >
                <div className="socialMediaModalLinkIcon">
                  {single.icon === "custom"
                    ? single.custom_label.charAt(0)
                    : single.icon}
                </div>
                <input
                  defaultValue={single.url}
                  placeholder="Url"
                  onChange={(e) => handleModalUrlChange(e, index)}
                ></input>
                <FiTrash2
                  onClick={() => handleModalMediaDelete(index)}
                  className="socialLinkDeleteIcon"
                />
              </div>
              {mediaLinkErrors[`${index}.url`] ? (
                <div style={{ textAlign: "start" }}>
                  <span className="errorText">
                    {mediaLinkErrors[`${index}.url`]}
                  </span>
                </div>
              ) : null}
            </>
          ))}
        </Modal.Body>

        <Modal.Footer className="mediaModalFooter">
          <Button variant="primary" onClick={handleMedialSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={uploadImageOpen}
        onHide={handleUploadImageClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header className="mediaModalHeader d-flex justify-content-between">
          <span>Upload</span>
          <AiOutlineClose onClick={handleUploadImageClose} />
        </Modal.Header>

        <Modal.Body className="mediaModalBody">
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div
              className={`d-flex justify-content-center align-items-center flex-column imageUpload`}
            >
              <BsImageFill />
              <span>
                Drop your Images here, or <span>Browse</span>
              </span>
              <span>Support JPG, PNG, Only</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={colorPickerOpen}
        onHide={handleColorPickerClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="mediaModalHeader">
          <span>Color Picker</span>
          <AiOutlineClose onClick={handleColorPickerClose} />
        </Modal.Header>

        <Modal.Body className={`d-flex justify-content-center mediaModalBody`}>
          <SketchPicker
            color={cardFunction.color}
            onChangeComplete={(color) => {
              brandingOverridesRef.current.color = true;
              setCardFunction({ ...cardFunction, color: color.hex });
              setCustomColor(true);
            }}
          />
        </Modal.Body>
      </Modal>

      <style type="text/css">
        {`
        
        .phoneNumberInput {
          font-size: 14px !important;
        }
        .addPhoneInput .react-tel-input .form-control{
          padding: 18.5px 5px 18.5px 52px;
          border: 0 !important;
          width:100%;
        }

        .react-tel-input .selected-flag{
          padding: 0 0 0 12px;
        }
        .customSelect.form-select{
          padding: 9px 14px;

        }
        .phoneInputWrapper{
            border: 2px solid #DAE9F4;
            border-radius: 25px;
        }
        .phoneInputWrapper.errorInput {
          border: 2px solid #e35252 !important;
        }
        .phoneInputWrapper:focus-within {
          border: 2px solid #DAE9F4;
        }
        .addCardSelect.globalInputWithIcon{
          border: 0 !important;
          border-radius: 0;
          border-right: 2px solid #DAE9F4 !important;
        }

        .gridDesign .contactInfoInner {
          display: flex;
          flex-wrap: wrap;
          justify-content:space-between;
        }
        .gridDesign .infoContnt {
          width: 48%;
          flex: 0 0 auto;
          padding: 0.5rem;
          display: block;
          text-align: center;
          background:#fff;
          border-radius: 5px;
        }
        .gridDesign .infoContnt a{
          // white-space:normal;
          // display: inline-flex;
          word-break: break-word;
        }
        .gridDesign .contactInfo h6{
          width:100%;
        }
        .gridDesign .moreInfoIcon{
          max-width:38px;
          max-height:38px;
          margin:0 0 10px;
        }
        .treeDesign .contactInfoInner{position:relative;padding-left:15px}
        .treeDesign .contactInfoInner:before{
          content:"";
          border-left: 1px solid #B2B2B2;
          height: 100%;
          position: absolute;
          top: 10px;
          left: 0px;
        }
        .treeDesign .contactInfoInner h6, .treeDesign .contactInfoInner .infoContnt{
          position:relative;
        }
        .treeDesign .contactInfoInner h6:before{
          content:"";
          width: 15px;
          position: absolute;
          left: -15px;
          top: 0px;
          bottom: 0;
          height: 1px;
          margin: auto;
          background-color: #B2B2B2;
        }
        .treeDesign .contactInfoInner .infoContnt:before{
          content:"";
          width: 15px;
          position: absolute;
          height: 1px;
          background-color: #B2B2B2;
          left: -15px;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .treeDesign .contactInfoInner .infoContnt:after{
          content:"";
          width: 5px;
          height: 5px;
          background-color: #B2B2B2;
          border-radius: 50%;
          position: absolute;
          left: -2.4%;
        }
        .iconDesign .contactInfoInner{
          display:flex;
          flex-wrap:wrap;
        }
        .iconDesign .contactInfo h6{
          width:100%;
        }
        .iconDesign .contactInfoInner .infoContnt{
          width:30.33333%;
          flex: 0 0 auto;
          margin-right:3%;
        }
        .iconDesign .contactInfoInner .infoContnt .moreInfoIcon{
          display:none;
        }
        .iconDesign .contactInfoInner .infoContnt .subHeading{
          display:none;
        }
        .profileImg.circle div,
        .profileImg.circle img {
          border-radius: 50%;
          transition: 0.5s all ease;
        }
        .profileImg.square div,
        .profileImg.square img {
          border-radius: 2px;
          transition: 0.5s all ease;
        }
        .profileImg.rectangular div,
        .profileImg.rectangular img {
          border-radius: 2px;
          width: 90px;
          height: 65px;
          transition: 0.5s all ease;
        }
        .logoWrapper.circle div,
          .logoWrapper.circle img {
            border-radius: 50%;
            transition: 0.5s all ease;
          }
          .logoWrapper.square div,
          .logoWrapper.square img {
            border-radius: 2px;
            transition: 0.5s all ease;
          }
          .logoWrapper.rectangular div,
          .logoWrapper.rectangular img {
            border-radius: 2px;
            width: 50px;
            height: 25px;
            transition: 0.5s all ease;
          }
	`}
      </style>

      {preview && (
        <CropImageModal
          show={showModal}
          image={preview}
          handleCloseModal={handleCloseModal}
          result={result}
          setResult={setResult}
          setFileData={setFileData}
          crop={crop}
          setCrop={setCrop}
        />
      )}
    </>
  );
};

export default EditCardFunctions;
